import { Box, Grid, Typography } from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import GroupIcon from '@mui/icons-material/Group';
import QuickActionCard from '@/components/ui/QuickActionCard.tsx';

export default function InvestorHome() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Bienvenido inversor
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Selecciona una opción para empezar
      </Typography>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6} md={3}>
          <QuickActionCard
            title="Mis inversiones"
            icon={<BusinessCenterIcon />}
            to="/inversiones"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <QuickActionCard title="Oportunidades" icon={<HomeWorkIcon />} to="/oportunidades" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <QuickActionCard title="PSIs" icon={<GroupIcon />} to="/psis" />
        </Grid>
      </Grid>
    </Box>
  );
}
